// extracted by mini-css-extract-plugin
export default {"ButtonPlaceholder":"Fz1QhfUG","ButtonSkeleton":"PbtRSxeJ","IconPlaceholder":"ROJbCQT_","TextArea":"bCSWy7Y6","TextAreaPlaceholder":"oeSASwAb","PlaceholderContent":"tb1VyK5r"};